import React from 'react';
import { useFormContext } from 'react-hook-form';

import { FormContainerTextfield } from '@/components/common/Form/Container/Textfield';
import { FormLabel } from '@/components/common/Form/Label';
import { FormLayoutFieldset } from '@/components/common/Form/Layout/Fieldset';
import { ToggleLabelButton } from '@/components/common/Form/ToggleLabelButton';
import { TitleSectionTitle } from '@/components/common/Title/SectionTitle';
import { PLACEHOLDER } from '@/definition/PLACEHOLDER';

type TSectionProps = {
  id?: string;
  original: {
    postal_code?: string;
    address1?: string;
    address2?: string;
    email?: string;
  };
};

export const ResumeFormSectionAddress = ({ id, original }: TSectionProps): React.ReactElement => {
  const methods = useFormContext();
  const [postal_code_check, address1_check, address2_check, email_check] = methods.watch([
    'postal_code_check',
    'address1_check',
    'address2_check',
    'email_check',
  ]);

  return (
    <div id={id}>
      <TitleSectionTitle>
        <div className="flex items-center">
          <span className="mr-4">現住所</span>
        </div>
      </TitleSectionTitle>
      <div className="mbx-utils-stack-v--16">
        <FormLayoutFieldset>
          <ToggleLabelButton name="postal_code_check" className="mb-16" />
          <FormLabel label="郵便番号" type="small"></FormLabel>
          {postal_code_check ? (
            <FormContainerTextfield
              name="postal_code"
              className="w-150 mkt_mask_items"
              placeholder={PLACEHOLDER.postal_code}
              type="number"
            />
          ) : (
            <div className="w-150 mkt_mask_items pointer-events-none opacity-40">
              <div className="mbx-formContainer--textfield-wrapper">
                <input
                  type="number"
                  className="mbx-formContainer mbx-formContainer--textfield"
                  placeholder={PLACEHOLDER.postal_code}
                  value={original.postal_code ? original.postal_code : undefined}
                  readOnly
                />
              </div>
            </div>
          )}
        </FormLayoutFieldset>
        <FormLayoutFieldset>
          <ToggleLabelButton name="address2_check" className="mb-16 mt-16" />
          <FormLabel label="住所" type="small"></FormLabel>
          {address2_check ? (
            <FormContainerTextfield
              name="address2"
              className="mkt_mask_items"
              placeholder={PLACEHOLDER.address2}
            />
          ) : (
            <div className="mkt_mask_items pointer-events-none opacity-40">
              <div className="mbx-formContainer--textfield-wrapper">
                <input
                  type="text"
                  className="mbx-formContainer mbx-formContainer--textfield"
                  placeholder={PLACEHOLDER.address2}
                  value={original.address2 ? original.address2 : undefined}
                  readOnly
                />
              </div>
            </div>
          )}
        </FormLayoutFieldset>
        <FormLayoutFieldset>
          <ToggleLabelButton name="address1_check" className="mb-16 mt-16" />
          <FormLabel label="住所ふりがな" type="small"></FormLabel>
          {address1_check ? (
            <FormContainerTextfield
              name="address1"
              className="mkt_mask_items"
              placeholder={PLACEHOLDER.address1}
            />
          ) : (
            <div className="mkt_mask_items pointer-events-none opacity-40">
              <div className="mbx-formContainer--textfield-wrapper">
                <input
                  type="text"
                  className="mbx-formContainer mbx-formContainer--textfield"
                  placeholder={PLACEHOLDER.address1}
                  value={original.address1 ? original.address1 : undefined}
                  readOnly
                />
              </div>
            </div>
          )}
        </FormLayoutFieldset>
        <FormLayoutFieldset>
          <ToggleLabelButton name="email_check" className="mb-16 mt-16" />
          <FormLabel label="メールアドレス" type="small"></FormLabel>
          {email_check ? (
            <FormContainerTextfield
              name="email"
              className="mkt_mask_items"
              placeholder={PLACEHOLDER.email}
            />
          ) : (
            <div className="mkt_mask_items pointer-events-none opacity-40">
              <div className="mbx-formContainer--textfield-wrapper">
                <input
                  type="text"
                  className="mbx-formContainer mbx-formContainer--textfield"
                  placeholder={PLACEHOLDER.email}
                  value={original.email ? original.email : undefined}
                  readOnly
                />
              </div>
            </div>
          )}
        </FormLayoutFieldset>
        <FormLayoutFieldset>
          <FormLabel label="電話番号" type="small"></FormLabel>
          <FormContainerTextfield name="tel" readOnly={true} className="mkt_mask_items" />
        </FormLayoutFieldset>
      </div>
    </div>
  );
};
